<template>
	<form @submit.prevent="emitData" enctype="multipart/form-data" novalidate>
		<div class="block block-rounded block-themed block-transparent mb-0">
			<div class="block-header bg-primary-dark">
				<h3 class="block-title">
					<i class="fa fa-pencil-alt mr-1"></i> 
					Create a new Venue
				</h3>
				<div class="block-options">
					<button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
						<i class="fa fa-fw fa-times"></i>
					</button>
				</div>
			</div>
			<div class="block-content">
				<div class="form-group">
					<label for="venue-name">Venue Name</label>
					<input type="text" class="form-control" id="venue-name" v-model="venue.name">
					<div class="invalid-feedback" style="display: block;" v-if="errors.venueName">
						{{ errors.venueName }}
					</div>
				</div>
				<div class="form-group">
					<label for="venue-email">Email</label>
					<input type="email" class="form-control form-control" id="venue-email" name="message" rows="6" v-model="venue.email"/>
					<div class="invalid-feedback" style="display: block;" v-if="errors.venueEmail">
						{{ errors.venueEmail }}
					</div>
				</div>
				<div class="form-group">
					<label for="venue-phone">Phone</label>
          <bw-phone v-model="venue.phone" :allow-extensions="false" :is-required="true"></bw-phone>
					<div class="invalid-feedback" style="display: block;" v-if="errors.venuePhone">
						{{ errors.venuePhone }}
					</div>
				</div>
        <!-- Contact information -->
        <div class="form-group">
          <h4>Contact Information</h4>
        </div>
        <div class="form-group">
          <label for="contact-first-name">First Name</label>
          <input type="text" class="form-control" id="contact-first-name" v-model="venue.contact.first_name">
          <div class="invalid-feedback" style="display: block;" v-if="errors.contactFirstName">
            {{ errors.contactFirstName }}
          </div>
        </div>

        <div class="form-group">
          <label for="contact-last-name">Last Name</label>
          <input type="text" class="form-control" id="contact-last-name" v-model="venue.contact.last_name">
          <div class="invalid-feedback" style="display: block;" v-if="errors.contactLastName">
            {{ errors.contactLastName }}
          </div>
        </div>
        <div class="form-group">
          <label for="contact-email">Email</label>
          <input type="email" class="form-control form-control" id="contact-email" name="message" rows="6" v-model="venue.contact.email"/>
          <div class="invalid-feedback" style="display: block;" v-if="errors.contactEmail">
            {{ errors.contactEmail }}
          </div>
        </div>
        <div class="form-group">
          <label for="contact-phone">Phone</label>
          <bw-phone v-model="venue.contact.phone" :allow-extensions="true" :extension="venue.contact.phone_ext" @extension="venue.contact.phone_ext = $event" :is-required="true"></bw-phone>
          <div class="invalid-feedback" style="display: block;" v-if="errors.contactPhone">
            {{ errors.contactPhone }}
          </div>
        </div>
        <div class="form-group">
          <label for="contact-secondary-phone">Secondary Phone</label>
          <bw-phone
              v-model="venue.contact.secondary_phone"
              :allow-extensions="true"
              :extension="venue.contact.secondary_phone_ext"
              @extension="venue.contact.secondary_phone_ext = $event"
          ></bw-phone>
          <div class="invalid-feedback" style="display: block;" v-if="errors.contactSecondaryPhone">
            {{ errors.contactSecondaryPhone }}
          </div>
        </div>
				
			</div>
			<div class="block-content block-content-full text-right border-top">
				<button type="button" class="btn btn-alt-primary mr-1" data-dismiss="modal" id="close-new-message">Cancel</button>
				<button type="submit" class="btn btn-primary" :disabled="isUpdating">
					Create
				</button>
			</div>
		</div>
	</form>
</template>

<script>

export default {
	data: () => {
		return {
			errors: {},
			venue: {
				name: '',
				email: '',
				phone: '',
        contact: {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          phone_ext: '',
          secondary_phone: '',
          secondary_phone_ext: '',
        }
			},
			isUpdating: false,
		}
	},
	methods: {
		emitData() {
			if(this.validate()) {
				this.isUpdating = true
				this.$emit(`new-venue`, this.venue, '/venues' )

				for (let prop in this.venue) {
          if (typeof this.venue[prop] === 'string') {
            this.venue[prop] = ''
          } else if (typeof this.venue[prop] === 'object') {
            for (let innerProp in this.venue[prop]) {
              this.venue[prop][innerProp] = ''
            }
          }
				}

				this.isUpdating = false
			}
		},
		validate() {
			this.errors = {};
			let validationConditions = [
				{ condition: !this.venue.name, errorName: 'venueName', errorMessage: 'This Field Cannot be Empty.' },
				{ condition: !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(this.venue.phone), errorName: 'venuePhone', errorMessage: 'This is not a valid phone number.' },
				{ condition: !/^[^\s@]+@[^\s@]+$/.test(this.venue.email), errorName: 'venueEmail', errorMessage: 'This is not a valid email.' },
        { condition: !this.venue.contact.first_name, errorName: 'contactFirstName', errorMessage: 'This Field Cannot be Empty.' },
        { condition: !this.venue.contact.last_name, errorName: 'contactLastName', errorMessage: 'This Field Cannot be Empty.' },
        { condition: !/^[^\s@]+@[^\s@]+$/.test(this.venue.contact.email), errorName: 'contactEmail', errorMessage: 'This is not a valid email.' },
        { condition: !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(this.venue.contact.phone), errorName: 'contactPhone', errorMessage: 'This is not a valid phone number.' },
        { condition: !/^$|^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(this.venue.contact.secondary_phone), errorName: 'contactSecondaryPhone', errorMessage: 'This is not a valid phone number.' },
			]
			//loops through each condition then applies it to the error name.
			validationConditions.forEach(v => v.condition ? this.errors[v.errorName] = v.errorMessage : null)

			if( Object.keys(this.errors).length === 0 ) {
				return true;
			}

			this.error_msg = 'Please fix any errors before saving.';
			return false;
		}
	}
}
</script>

<style lang="scss">
	.error {
		color: red;
		font-weight: bold;
	}
</style>
